import type { PageContext } from "vike/types";
import type { Data } from './+data'
import type { LocaleCode } from '@repo/types'
import { getAddressFromDeal, generateSmartTitleString } from '@repo/ui';

export default function title(pageContext: PageContext<Data>): string {
  const deal = pageContext.data.property?.deals?.[0];
  const page = pageContext.data.page;
  const locale = (pageContext.locale as LocaleCode) ?? 'en';
  const t = pageContext.i18n.global.t;

  if (deal) {
    const generatedTitle = generateSmartTitleString(deal, locale, false) ?? deal.name;
    const address = getAddressFromDeal(deal, locale) ?? deal.building.address

    if (generatedTitle) {
      return t('seo.property.title', {
        title: generatedTitle,
        address: address,
      })
    }
  }

  // Final fallback
  return t('seo.property.fallback.title');
}
